import React from 'react';
import { eventBus, CONTEXT_MENU_ITEM, LAYER_ACTIONS } from '../../utils';

import './styles.scss';

const ContextMenu = ({ isShow, position }) => {
  const onMenuItemClick = (item) => {
    eventBus.emit('handle-context-menu', CONTEXT_MENU_ITEM[item]);
  };

  const onLayerClick = (e, item) => {
    e.stopPropagation();
    eventBus.emit('handle-layer-context', item);
  };

  const renderMenuItem = () =>
    Object.keys(CONTEXT_MENU_ITEM).map((i, index) => (
      <div key={index} onClick={() => onMenuItemClick(i)}>
        <li className="mo_context-menu__content">
          <div>{CONTEXT_MENU_ITEM[i].text}</div>
          <div className="mo_context-menu__content__shortcut">{CONTEXT_MENU_ITEM[i].shortcut}</div>
        </li>
        {CONTEXT_MENU_ITEM[i].divider && <div className="mo__context-menu__divider" />}
      </div>
    ));

  const renderLayerItem = () => (
    <div>
      <div className="mo__context-menu__divider" />
      {LAYER_ACTIONS.map((item, index) => (
        <div key={`${item.action}_${index}`} onClick={(e) => onLayerClick(e, item.action)}>
          <li className="mo_context-menu__content">
            <div>{item.title}</div>
            <div className="mo_context-menu__content__shortcut">{item.shortcut || ''}</div>
          </li>
        </div>
      ))}
    </div>
  );

  return (
    <>
      <ul
        className="mo__context-menu"
        style={{ display: isShow ? 'block' : 'none', top: position.y, left: position.x }}
      >
        {renderMenuItem()}
        {renderLayerItem()}
      </ul>
    </>
  );
};

export default ContextMenu;
